/* eslint-disable jsx-a11y/anchor-is-valid */
import secondaryComponents from "../../../../../../components/secondaryComponents";
import { motion } from "framer-motion";
import primaryComponents from "../../../../../../components/primaryComponents";
import globalStyles from "../../../../../../assets/styles/base/globalPage.module.scss";
import { PlusIcon } from "../../../../../../assets/svgIcons";
import { useAllPurchaseOrders } from "./useAllPurchaseOrders";
import { useNavigate } from "react-router-dom";
import { pathConstants } from "../../../../../../routes/pathContants";
import { POTable } from "../../../../../../components/secondaryComponents/PurchaseOrder";

export const AllPurchaseOrders = () => {
  const {
    search,
    storeList,
    purchaseOrderStatus,
    purchaseOrders,
    isLoadingPO,
    isLoadingExtra,
    metaDetails,
    suppliers,
    pOCategories,
    filterByDate,
    filterByStoreId,
    filterBySearch,
    gotoPage,
    filterByKey,
  } = useAllPurchaseOrders();
  const navigate = useNavigate();
  const fulfillmentStates = [
    {
      name: "Open",
      id: "OPEN",
    },
    { name: "Closed", id: "CLOSED" },
  ];

  return (
    <secondaryComponents.MetaSetter
      title="Lumi Merchant | Purchase Orders"
      description="View of all purchase orders"
    >
      <secondaryComponents.RequestLoaderTrigger>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className={`${globalStyles.pageColumnGaps}`}
        >
          <div>
            <h4 className="mb-0">Purchase Orders</h4>
            <p>Quickly raise and track your supplier orders.</p>
          </div>

          <div className={globalStyles.rowNavigations}>
            {purchaseOrderStatus?.map((item, index) => (
              <a
                key={index}
                className={`${globalStyles.rowNavigations__item} ${
                  search.get("status") === item?.value
                    ? globalStyles.active
                    : ""
                }`}
                onClick={() => filterByKey("status", item?.value)}
              >
                {item?.label}{" "}
                {item?.value === "IN_REVIEW" ? (
                  <span className={`ml-1 ${globalStyles.noOfPends}`}>
                    {metaDetails?.total_in_review || 0}
                  </span>
                ) : null}
              </a>
            ))}
          </div>

          <div className={globalStyles.pageHeaders}>
            <p style={{ textTransform: "lowercase" }}>
              {metaDetails?.total} {search.get("status")?.replace("_", " ")}
            </p>

            <secondaryComponents.NavigateWithPermission
              permissionParentKey={"Inventory Management"}
              permissionChildKey={"can_create_or_update_purchase_order"}
            >
              <primaryComponents.Button
                classNames={"btn btn--primary ml-auto"}
                onClick={() =>
                  navigate(pathConstants.INVENTORY_PURCHASE_ORDER_CREATE)
                }
              >
                <PlusIcon className="mr-1" /> Create PO
              </primaryComponents.Button>
            </secondaryComponents.NavigateWithPermission>
          </div>

          {/* table section */}
          <div className={`${globalStyles.tableWrapper}`}>
            <div className={`${globalStyles.tableHeader}`}>
              <primaryComponents.SearchField
                classNames={`${globalStyles.searchField}`}
                placeholder="Search by PO number or supplier"
                trigger={(value) => filterBySearch(value)}
                value={search.get("query") || ""}
                triggerOnInput={true}
                showsearchBtn={true}
                showClearBtn={true}
              />

              <secondaryComponents.LoaderHelper
                isLoading={isLoadingExtra}
                classNames="mt-2"
              >
                <div className="ml-auto" style={{ width: "140px" }}>
                  <primaryComponents.SelectField
                    options={[
                      {
                        name: "All stores",
                        id: null,
                      },
                      ...storeList,
                    ]}
                    idKey="id"
                    nameKey="name"
                    onChange={(value) => {
                      filterByStoreId(value);
                    }}
                    value={
                      storeList?.find(
                        (store) => `${store?.id}` === search.get("store_id"),
                      )?.name || "Filter store"
                    }
                    floatError={false}
                    isSearchable={false}
                  />
                </div>
                <div style={{ width: "160px" }}>
                  <primaryComponents.SelectField
                    options={[
                      {
                        name: "All suppliers",
                        id: null,
                      },
                      ...suppliers,
                    ]}
                    idKey="id"
                    nameKey="name"
                    onChange={(value) => {
                      filterByKey("supplier_id", value);
                    }}
                    value={
                      storeList?.find(
                        (store) => `${store?.id}` === search.get("supplier_id"),
                      )?.name || "Filter Supplier"
                    }
                    floatError={false}
                    isSearchable={false}
                  />
                </div>
                <div style={{ width: "170px" }}>
                  <primaryComponents.SelectField
                    options={[
                      {
                        name: "All Categories",
                        id: null,
                      },
                      ...pOCategories,
                    ]}
                    idKey="id"
                    nameKey="name"
                    onChange={(value) => {
                      filterByKey("category_id", value);
                    }}
                    value={
                      storeList?.find(
                        (store) => `${store?.id}` === search.get("category_id"),
                      )?.name || "Filter Category"
                    }
                    floatError={false}
                    isSearchable={false}
                  />
                </div>
                <div style={{ width: "180px" }}>
                  <primaryComponents.SelectField
                    options={[
                      { name: "All fulfillment" },
                      ...fulfillmentStates,
                    ]}
                    idKey="id"
                    nameKey="name"
                    onChange={(value) => {
                      filterByKey("fulfillment_state", value);
                    }}
                    value={
                      fulfillmentStates?.find(
                        (fulfillmentState) =>
                          `${fulfillmentState?.id}` ===
                          search.get("fulfillment_state"),
                      )?.name || "Filter Fulfillment"
                    }
                    floatError={false}
                    isSearchable={false}
                  />
                </div>
                <primaryComponents.DateRangeInput
                  startDate={search.get("start_date")}
                  endDate={search.get("end_date")}
                  onChange={filterByDate}
                  showPlaceholder={true}
                />
              </secondaryComponents.LoaderHelper>
            </div>

            {/* table section */}
            <secondaryComponents.LoaderHelper
              isLoading={isLoadingPO}
              classNames="mt-5"
            >
              <POTable
                purchaseOrders={purchaseOrders}
                metaDetails={metaDetails}
                gotoPage={gotoPage}
              />
            </secondaryComponents.LoaderHelper>
          </div>
        </motion.div>
      </secondaryComponents.RequestLoaderTrigger>
    </secondaryComponents.MetaSetter>
  );
};
